<template>
  <div class="life-page">
    <section class="life-panel">
      <div class="life-panel__head">
        <h2 class="life-panel__title">路由配置查询</h2>
        <el-button type="primary" icon="el-icon-plus" size="small" @click="openEditor()">新增配置</el-button>
      </div>
    </section>

    <section class="life-panel">
      <div class="life-panel__head">
        <h2 class="life-panel__title">当前配置</h2>
      </div>
      <el-table v-loading="loading" :data="rows" border>
        <el-table-column prop="companyId" label="物业公司" width="150" />
        <el-table-column prop="metaServiceId" label="元服务ID" min-width="150" />
        <el-table-column prop="serviceLink" label="元服务链接" min-width="250" />
        <el-table-column label="发布状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="publishTag(scope.row.publishState)" size="small">
              {{ publishName(scope.row.publishState) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="fallbackPolicy" label="降级策略" width="90" align="center" />
        <el-table-column prop="createTime" label="创建时间" width="170" />
        <el-table-column label="操作" width="80" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="openEditor(scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </section>

    <el-dialog title="编辑路由配置" :visible.sync="editorVisible" width="520px" @closed="onDialogClosed">
      <el-form ref="formRef" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="物业公司" prop="companyId">
          <el-select v-model="form.companyId" placeholder="请选择物业公司" filterable style="width: 100%">
            <el-option v-for="c in companyOptions" :key="c.storeId" :label="c.name" :value="c.storeId" />
          </el-select>
        </el-form-item>
        <el-form-item label="元服务ID">
          <el-input v-model="form.metaServiceId" maxlength="64" placeholder="鸿蒙元服务ID" />
        </el-form-item>
        <el-form-item label="元服务链接">
          <el-input v-model="form.serviceLink" maxlength="512" placeholder="鸿蒙元服务链接" />
        </el-form-item>
        <el-form-item label="发布状态" prop="publishState">
          <el-select v-model="form.publishState" style="width: 100%">
            <el-option label="草稿" value="DRAFT" />
            <el-option label="未发布" value="UNPUBLISHED" />
            <el-option label="已发布" value="PUBLISHED" />
            <el-option label="已过期" value="EXPIRED" />
          </el-select>
        </el-form-item>
        <el-form-item label="降级策略">
          <el-select v-model="form.fallbackPolicy" style="width: 100%">
            <el-option label="微信兜底" value="WECHAT" />
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="editorVisible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="submit">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { listRouteConfigs, saveRouteConfig } from '@/api/aggregateCode/aggregateCodeApi'
import { getStoreList } from '@/api/store/storeApi'

function emptyForm() {
  return { companyId: '', metaServiceId: '', serviceLink: '', publishState: 'DRAFT', fallbackPolicy: 'WECHAT' }
}

export default {
  name: 'AggregateCodeRouteConfigList',
  data() {
    return {
      loading: false, saving: false, editorVisible: false,
      rows: [], companyOptions: [],
      form: emptyForm(),
      rules: {
        companyId: [{ required: true, message: '请选择物业公司', trigger: 'change' }],
        publishState: [{ required: true, message: '请选择发布状态', trigger: 'change' }]
      }
    }
  },
  created() { this.load(); this.loadCompanies() },
  methods: {
    async load() {
      this.loading = true
      try {
        const res = await listRouteConfigs({ page: 1, row: 50 })
        this.rows = res.data || []
      } catch (error) {
        this.$message.error(error.message || '加载路由配置失败')
      } finally { this.loading = false }
    },
    async loadCompanies() {
      try {
        const res = await getStoreList({ page: 1, row: 200 })
        this.companyOptions = res.data || []
      } catch (_) { /* ignore */ }
    },
    publishName(s) {
      return { DRAFT: '草稿', UNPUBLISHED: '未发布', PUBLISHED: '已发布', EXPIRED: '已过期' }[s] || s
    },
    publishTag(s) {
      return { DRAFT: 'info', UNPUBLISHED: 'warning', PUBLISHED: 'success', EXPIRED: 'danger' }[s] || 'info'
    },
    openEditor(row) {
      this.form = row ? { ...row } : emptyForm()
      this.editorVisible = true
      this.$nextTick(() => this.$refs.formRef && this.$refs.formRef.clearValidate())
    },
    onDialogClosed() {
      this.$refs.formRef && this.$refs.formRef.resetFields()
    },
    submit() {
      this.$refs.formRef.validate(async valid => {
        if (!valid) return
        this.saving = true
        try {
          await saveRouteConfig(this.form)
          this.$message.success('路由配置已保存')
          this.editorVisible = false
          this.load()
        } catch (error) {
          this.$message.error(error.message || '保存失败')
        } finally { this.saving = false }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import './life.scss';
</style>
